export const DUMMY_RESPONSE = [
  {
    alertName: 'DCGMThermalViolationH100LC',
    alertStatus: 'firing',
    cluster: 'ml-dev-usw1a',
    clusterOrg: 'cw1337',
    pod: 'slurm-h100-205-189',
    node: 'g1c7168',
    occurrences: {
      '1746125400000': 1,
      '1746128400000': 1,
    },
  },
  {
    alertName: 'DCGMThrottleSWThermal',
    alertStatus: 'firing',
    cluster: 'ml-dev-usw1a',
    clusterOrg: 'cw1337',
    pod: 'slurm-h100-205-189',
    node: 'g1c7168',
    occurrences: {
      '1746124500000': 1,
      '1746124800000': 1,
      '1746125700000': 1,
      '1746126300000': 1,
      '1746128700000': 1,
      '1746129000000': 1,
      '1746130500000': 1,
      '1746130800000': 1,
      '1746132600000': 1,
      '1746132900000': 1,
    },
  },
  {
    alertName: 'IBFlappingSingleNodeInterface',
    alertStatus: 'firing',
    cluster: 'ml-dev-usw1a',
    clusterOrg: 'cw1337',
    pod: 'slurm-h100-209-025',
    node: 'g78b186',
    occurrences: {
      '1746161400000': 1,
    },
  },
  {
    alertName: 'IBFlappingSingleNodeInterface',
    alertStatus: 'firing',
    cluster: 'ml-dev-usw1a',
    clusterOrg: 'cw1337',
    pod: 'slurm-h100-209-023',
    node: 'g78b1d2',
    occurrences: {
      '1746161400000': 1,
    },
  },
  {
    alertName: 'NodeIBLinkFault',
    alertStatus: 'firing',
    cluster: 'ml-dev-usw1a',
    clusterOrg: 'cw1337',
    node: 'g78b186',
    pod: 'slurm-h100-209-025',
    occurrences: {
      '1746161400000': 1,
    },
  },
  {
    alertName: 'NodeIBLinkFault',
    alertStatus: 'firing',
    cluster: 'ml-dev-usw1a',
    clusterOrg: 'cw1337',
    pod: 'slurm-h100-209-023',
    node: 'g78b1d2',
    occurrences: {
      '1746161400000': 1,
    },
  },
];

let index = 0;
export const DUMMY_ISSUES = (statusFilter: string[]) =>
  DUMMY_RESPONSE.flatMap((issue, root_index) => {
    const occurrence = Object.keys(issue.occurrences)[0];
    const firstTimestamp = parseInt(occurrence) - 5 * 60 * 1000;
    const lastTimestamp =
      parseInt(
        Object.keys(issue.occurrences)[
          Object.keys(issue.occurrences).length - 1
        ]
      ) +
      5 * 60 * 1000;
    return {
      alertName: issue.alertName,
      alertStatus: issue.alertStatus,
      description:
        'During training, GPU utilization dropped while CPU and disk usage stayed high, indicating a data loading bottleneck likely due to insufficient data loader workers or slow disk reads. This reduced overall training speed.',
      id: `${root_index}-${index++}`,
      linkURL: `https://cks-grafana.coreweave.com/d/ddbdicm9sw7c5x/node-details?orgId=1&var-node=${issue.node}&from=${firstTimestamp}&to=${lastTimestamp}`,
      node: issue.node,
      runId: 'mc6z6vup',
      timestamp: parseInt(occurrence),
      title: issue.alertName ?? '',
    };
  }).filter(issue => {
    return statusFilter.includes(issue.alertStatus);
  });
